export const validatePassword = (value: string): string | undefined => {
  const errors: string[] = [];
  if (!value) {
    errors.push("Password is required");
  } else if (value.length < 8) {
    errors.push("Password must be at least 8 characters long");
  } else if (!/[A-Z]/.test(value)) {
    errors.push("Password must contain at least one uppercase letter");
  } else if (!/[a-z]/.test(value)) {
    errors.push("Password must contain at least one lowercase letter");
  } else if (!/[0-9]/.test(value)) {
    errors.push("Password must contain at least one number");
  } else if (!/[!@#$%^&*]/.test(value)) {
    errors.push(
      "Password must contain at least one special character (!@#$%^&*)"
    );
  }
  return errors.length > 0 ? errors.join(", ") : undefined;
};
